'use client';
import Script from 'next/script';
import { getAdTagURL } from '../ads/VideoAdTagURL';
import { useEffect, useRef } from 'react';

type Props = {
  greenvideoContentId: string;
  canonicalUrl: string;
  title: string;
  description?: string;
  thumbnail?: string;
};

export function GreenPlayer(props: Props) {
  const playerRef = useRef(undefined);

  const htmlId = 'green-video-player' + props.greenvideoContentId;

  useEffect(() => {
    //For tracking which articles have green video https://community.marfeel.com/t/multimedia-tracking/7483
    window.marfeel.cmd.push([
      'multimedia',
      function (multimedia) {
        multimedia.initializeItem(
          htmlId,
          'green-video',
          props.greenvideoContentId,
          'video',
          {
            title: props.title,
            description: props.description || '',
            thumbnail: props.thumbnail || '',
          },
          playerRef.current,
        );

        multimedia.registerEvent(props.canonicalUrl, 'GREEN-VIDEO-LOADED', 0);
      },
    ]);
  }, [htmlId, props.canonicalUrl, props.greenvideoContentId]);

  return (
    <>
      <Script
        src="https://cdn.greenvideo.io/players/gv.js"
        data-license-key="b90e39d3baadf30fb048b7ddbb510c0689638173"
        onReady={() => {
          if (!playerRef.current) return;
          const canonicalUrl = playerRef.current.dataset.canonicalUrl;
          playerRef.current.plugin.register(
            'pluginAdGetExternalVastTag',
            async function (params, getState) {
              return await getAdTagURL(
                `/9265542/pf-web-${params.mobile ? 'mobile' : 'desktop'}-video-${params.clickToPlay ? 'clicktoplay' : 'autoplay'}`,
                params.mobile,
                canonicalUrl,
              );
            },
          );
        }}
        strategy="lazyOnload"
      />
      <green-video
        id={htmlId}
        ref={playerRef}
        data-canonical-url={props.canonicalUrl}
        data-plugin-ad-get-external-vast-tag
        embed-id="Ft-9uwSM"
        content-id={props.greenvideoContentId}
        className="absolute top-0 right-0 bottom-0 left-0"
      />
    </>
  );
}
